import script from "./PaypalRecharge.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaypalRecharge.vue?vue&type=script&lang=ts&setup=true"

import "./PaypalRecharge.vue?vue&type=style&index=0&id=0323853a&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0323853a"]])

export default __exports__